/**
 * Created by jm on 2018/7/5.
 */
import { Message } from 'element-ui';
import dateFns from 'date-fns';
import { getItem } from './utils';

const antiReptilian = {
  install(Vue, options) {
    Vue.$antirept = checkText => {
      if (!checkText) return;
      let wrapperTemp = Vue.extend({
        // 1、创建构造器，定义模板
        template:
          '<div id="antiReptWrapper" style="padding-top:300px;position:fixed;top:0;left:0;width:100%;height:100%; background:rgba(0,0,0,0.5);z-index:9999 !important;"></div>'
      });
      let antiObj = new wrapperTemp().$mount().$el; // 2、创建实例
      antiObj.innerHTML = checkText;
      initScripts(antiObj);
      let App = document.getElementById('app');
      let body = document.getElementsByTagName('body')[0];
      let wrapper = document.getElementById('antiReptWrapper');
      if (wrapper) {
        return;
      }
      body.style.overflow = 'hidden';
      App.appendChild(antiObj); // 3、把创建的实例添加到App中
      window.checkSucceed = res => {
        // 4、验证通过后移除实例
        body.style.overflow = 'auto';
        App.removeChild(antiObj);
        if (Message) {
          //神策埋点
          let properties = {};
          let timeValue = new Date().getTime();
          let time = dateFns.format(timeValue, 'YYYY-MM-DD HH:mm:ss');
          properties.is_pass_anti_reptilian = true;
          properties.pass_anti_reptilian_time = time;
          window.sa.track('pass_anti_reptilian', properties);
          Message.success('验证通过');
        }
        window.location.reload();
      };
      window.checkError = () => {
        body.style.overflow = 'auto';
        App.removeChild(antiObj);
        window.location.reload();
      };
    };
  }
};

//重新引入js文件
const initScripts = function(cont) {
  let oldScripts = cont.getElementsByTagName('script');
  let newScripts = [];
  for (let i = 0; i < oldScripts.length; i++) {
    let newScript = document.createElement('script');
    newScript.type = 'text/javascript';
    newScript.innerHTML = oldScripts[i].innerHTML;
    if (oldScripts[i].src) {
      newScript.src = oldScripts[i].src;
    }
    newScripts.push(newScript);
  }
  while (oldScripts.length !== 0) {
    cont.removeChild(oldScripts[0]);
  }
  /*  console.log(newScripts);*/

  for (let i = 0; i < newScripts.length; i++) {
    if (i == 0) {
      cont.appendChild(newScripts[i]);
    } else {
      newScripts[i - 1].onload = newScripts[
        i - 1
      ].onreadystatechange = function(event) {
        /*  console.log(i,event);*/
        cont.appendChild(newScripts[i]);
      };
    }
  }
};

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(antiReptilian);
}

export default antiReptilian;



// WEBPACK FOOTER //
// ./src/common/antiReptilian.js